import { createAction, makeActionTrackable } from '@lingoda/core';

interface Credentials {
    username: string;
}

export default makeActionTrackable(createAction<Credentials>('auth/SEND_TOKEN'));
